"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const constants_1 = require("../constants");
const formatFieldDataListItem_1 = require("./formatFieldDataListItem");
exports.formatFieldDataList = (type, data, { fieldSchema, schema }) => R.pipe(R.map(item => formatFieldDataListItem_1.formatFieldDataListItem(type, item, { fieldSchema, schema })), R.groupBy(R.prop('type')), R.mapObjIndexed(R.map(R.prop('data'))), R.when(R.allPass([R.complement(R.has('reconnect')), R.always(R.equals(type, constants_1.MUTATION_TYPE.UPDATE))]), R.assoc('reconnect', [])))(data);
//# sourceMappingURL=formatFieldDataList.js.map